<template>
    <div>
        <apexchart
            height="350"
            type="bar"
            :options="chartOptions"
            :series="series"
            :height="chartHeight"
            ref="chart"
        ></apexchart>
    </div>
</template>
<script>
export default {
    props: {
        year: {
            type: Number | String,
            default: () => new Date().getFullYear(),
        },
        month: {
            type: Number | String,
            default: () => new Date().getMonth() + 1,
        },
    },
    data: () => ({
        chartOptions: {
            height: 9000,
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                    barHeight: '80%',
                    distributed: true,
                },
            },
            dataLabels: {
                enabled: false,
            },
            xaxis: {
                // title: {
                //     text: 'Porcentaje de cumplimiento',
                // },
                tickAmount: 10,
                labels: {
                    formatter: function (val) {
                        return val + '%'
                    },
                },
                position: 'top',
            },
            yaxis: {
                title: {
                    text: 'Clientes',
                },
                labels: {
                    maxWidth: 300,
                },
            },
            tooltip: {
                x: {
                    formatter: function (val) {
                        return val
                    },
                },
                y: {
                    formatter: function (
                        val,
                        { seriesIndex, dataPointIndex, w }
                    ) {
                        const cliente =
                            w.globals.initialSeries[seriesIndex].data[
                                dataPointIndex
                            ]
                        return `Cumplimiento: ${val}%<br>Listas realizadas: ${cliente.visit_days}`
                    },
                },
            },
            title: {
                text: 'Cumplimiento de listas de chequeo de supervisión',
                align: 'center',
            },
            colors: ['#008FFB'],
            legend: {
                show: false,
            },
            grid: {
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
        },
        series: [],
    }),
    watch: {
        series() {
            if (this.series.length === 0) return
            this.setColors()
            // console.table(this.chartOptions.colors)
            this.chartOptions.chartHeight = this.chartHeight
            this.$nextTick(() => {
                this.$refs.chart.updateOptions(this.chartOptions)
            })
        },
        chartHeight() {
            if (!this.$refs.chart) return
            this.$nextTick(() => {
                this.setColors()
                this.chartOptions.height = this.chartHeight
                this.$refs.chart.updateOptions(this.chartOptions)
            })
        },
    },
    computed: {
        chartHeight() {
            if (this.series.length === 0) return 9000
            return Math.max(this.series[0].data.length * 25, 350)
        },
    },
    methods: {
        setColors() {
            if (!this.series[0]) return
            this.chartOptions.colors = this.series[0].data.map((item) => {
                const val = parseFloat(item.y)
                if (val >= 90) return '#4CAF50' // Verde para alto cumplimiento
                if (val >= 70) return '#FFC107' // Amarillo para cumplimiento medio
                return '#F44336' // Rojo para bajo cumplimiento
            })
        },
        fetchData() {
            this.series = []
            this.loadChecklistCompliance()
        },
        async loadChecklistCompliance() {
            try {
                const { data } = await this.$repo.get(
                    'dashboards/supervisors/checklist-compliance',
                    {
                        year: this.year,
                        month: this.month,
                    }
                )
                this.series = [
                    {
                        name: 'Cumplimiento',
                        data: data.map(
                            ({
                                client_name,
                                venue_name,
                                compliance_percentage,
                                visit_days,
                            }) => ({
                                x: `${client_name} - ${venue_name}`,
                                y: parseFloat(compliance_percentage),
                                visit_days,
                            })
                        ),
                    },
                ]
                this.setColors()

                this.$emit('loaded', data)
            } catch (error) {
                toastr.error('Error al cargar los datos')
            }
        },
    },
    async mounted() {
        await this.loadChecklistCompliance()
        // this.series[0].data.sort((a, b) => (a.x < b.x ? 1 : -1))
        // this.chartOptions.title.text = `Cumplimiento de listas de chequeo de supervisión ${this.year}-${this.month}`

        // Actualizar colores basados en el porcentaje de cumplimiento
    },
}
</script>
